import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("nd_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("nd_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // If returning from Google OAuth callback, let the callback route handle it
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    loadMe();
  }, [loadMe]);

  const authenticate = useCallback((token, userObj) => {
    localStorage.setItem("nd_token", token);
    setUser(userObj);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("nd_token");
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, authenticate, logout, refresh: loadMe, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
